import React, { useState } from 'react'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'
import ListTable from 'core/components/listTable/ListTable'
import RoleBindingAnalysisDialog from './RoleBindingAnalysisDialog'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import { filterByOperation, renderOp } from './helpers'
import DriftResourceSummary from './DriftResourceSummary'
import { allKey } from 'app/constants'
import OperationsPicklist from './OperationsPicklist'

const useStyles = makeStyles((theme: Theme) => ({
  inspectIcon: {
    color: theme.palette.blue[500],
    cursor: 'pointer',
  },
}))

const InspectRoleBindingButton = ({ roleBinding }) => {
  const classes = useStyles({})
  const [dialogOpened, setDialogOpened] = useState(false)

  return (
    <>
      <FontAwesomeIcon className={classes.inspectIcon} onClick={() => setDialogOpened(true)}>
        search-plus
      </FontAwesomeIcon>
      {dialogOpened && (
        <RoleBindingAnalysisDialog
          roleBinding={roleBinding}
          onClose={() => setDialogOpened(false)}
        />
      )}
    </>
  )
}

const renderInspectButton = (_, roleBinding) => (
  <InspectRoleBindingButton roleBinding={roleBinding} />
)

const columns = [
  { id: 'op', label: '', render: renderOp },
  { id: 'name', label: 'Name' },
  { id: 'newValue.metadata.namespace', label: 'Namespace' },
  { id: 'path', label: '', render: renderInspectButton },
]

const RoleBindingAnalysis = ({ roleBindings, isImpactAnalysis, clusterId }) => {
  const [operation, setOperation] = useState(allKey)
  const mappedRoleBindings = roleBindings.map((roleBinding) => ({
    ...roleBinding,
    namespace: roleBinding.newValue?.metadata?.namespace,
    clusterId,
  }))
  const filteredRoleBindings = filterByOperation(mappedRoleBindings, operation)

  return (
    <>
      <DriftResourceSummary
        resourceType="Role Bindings"
        resources={roleBindings}
        isImpactAnalysis={isImpactAnalysis}
      />
      <div>
        <ListTable
          filters={
            <OperationsPicklist
              onChange={(value) => setOperation(value)}
              value={operation}
              isImpactAnalysis={isImpactAnalysis}
            />
          }
          showCheckboxes={false}
          searchTargets={['name']}
          columns={columns}
          data={filteredRoleBindings}
          rowsPerPage={10}
          uniqueIdentifier="path"
        />
      </div>
    </>
  )
}

export default RoleBindingAnalysis
